import React, {Component, Fragment} from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./Styles.module.css";

/**
 * @author Chris Okebata
 */

class CheckboxMat extends Component {

  render() {

    const {input, checkedStatus, styleStatus, handleOnChange, classes, label} = this.props;

    return(
      <Fragment>
        <FormControlLabel
          classes={{
            label: styles.label
          }}

          control={
            <Checkbox
              {...input}
              onChange={(event)=>{handleOnChange(event)}}
              style={ styleStatus ?
                {color: '#003300', fontSize: 2, margin: '5px 0 0 -2px'} :
                {color: '#aeaeae', fontSize: 2, margin: '5px 0 0 -2px'}}
              checked={checkedStatus}
            />
          }
          label={label}
        />
      </Fragment>
    )
  }
}

export {CheckboxMat}

